// File: src/pages/MessagingTab.js

import React from 'react';

function MessagingTab() {
    return (
        <>
            {/* Messaging privacy START */}
            <div className="card mb-4">
                {/* Title START */}
                <div className="card-header border-0 pb-0">
                    <h5 className="card-title">Messaging privacy settings</h5>
                    <p className="mb-0">
                        As young ye hopes no he place means. Partiality diminution
                        gay yet entreaties admiration. In mention perhaps attempt
                        pointed suppose. Unknown ye chamber of warrant of Norland
                        arrived.
                    </p>
                </div>
                {/* Card body */}
                <div className="card-body">
                    {/* Settings style */}
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item d-flex justify-content-between align-items-center px-0">
                            <div className="me-2">
                                <h6 className="mb-0">
                                    Enable message request notifications
                                </h6>
                            </div>
                            <div className="form-check form-switch">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="msgSwitchCheckChecked"
                                    defaultChecked
                                />
                            </div>
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-center px-0">
                            <div className="me-2">
                                <h6 className="mb-0">Invitations from your network</h6>
                            </div>
                            <div className="form-check form-switch">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="msgSwitchCheckChecked2"
                                    defaultChecked
                                />
                            </div>
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-center px-0">
                            <div className="me-2">
                                <h6 className="mb-0">
                                    Allow connections to add you on group
                                </h6>
                            </div>
                            <div className="form-check form-switch">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="msgSwitchCheckChecked3"
                                />
                            </div>
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-center px-0">
                            <div className="me-2">
                                <h6 className="mb-0">Reply to comments</h6>
                            </div>
                            <div className="form-check form-switch">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="msgSwitchCheckChecked4"
                                />
                            </div>
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-center px-0">
                            <div className="me-2">
                                <h6 className="mb-0">
                                    Messages from activity on my page or channel
                                </h6>
                            </div>
                            <div className="form-check form-switch">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="msgSwitchCheckChecked5"
                                    defaultChecked
                                />
                            </div>
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-center px-0">
                            <div className="me-2">
                                <h6 className="mb-0">Personalise tips for my page</h6>
                            </div>
                            <div className="form-check form-switch">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="msgSwitchCheckChecked6"
                                    defaultChecked
                                />
                            </div>
                        </li>
                    </ul>
                </div>
                {/* Button save */}
                <div className="card-footer pt-0 text-end border-0">
                    <button type="submit" className="btn btn-sm btn-primary mb-0">
                        Save changes
                    </button>
                </div>
            </div>
            {/* Messaging privacy END */}

            {/* Messaging experience START */}
            <div className="card">
                {/* Card header START */}
                <div className="card-header border-0 pb-0">
                    <h5 className="card-title">Messaging experience</h5>
                    <p className="mb-0">
                        Arrived off she elderly beloved him affixed noisier yet.
                    </p>
                </div>
                {/* Card body START */}
                <div className="card-body">
                    {/* Message START */}
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item d-sm-flex justify-content-between align-items-center px-0">
                            <div className="me-2">
                                <h6 className="mb-0">
                                    Read receipts and typing indicators
                                </h6>
                            </div>
                            <button className="btn btn-primary-soft btn-sm mt-1 mt-md-0">
                                <i className="bi bi-pencil-square"></i> Change
                            </button>
                        </li>
                        <li className="list-group-item d-sm-flex justify-content-between align-items-center px-0">
                            <div className="me-2">
                                <h6 className="mb-0">Message suggestions</h6>
                            </div>
                            <button className="btn btn-primary-soft btn-sm mt-1 mt-md-0">
                                <i className="bi bi-pencil-square"></i> Change
                            </button>
                        </li>
                        <li className="list-group-item d-sm-flex justify-content-between align-items-center px-0">
                            <div className="me-2">
                                <h6 className="mb-0">Message nudges</h6>
                            </div>
                            <button className="btn btn-primary-soft btn-sm mt-1 mt-md-0">
                                <i className="bi bi-pencil-square"></i> Change
                            </button>
                        </li>
                    </ul>
                    {/* Message END */}
                </div>
                {/* Card body END */}
                {/* Button save */}
                <div className="card-footer pt-0 text-end border-0">
                    <button type="submit" className="btn btn-sm btn-primary mb-0">
                        Save changes
                    </button>
                </div>
            </div>
            {/* Messaging experience END */}
        </>
    );
}

export default MessagingTab;